// @ts-nocheck
import React from "react";
import {
  Modal,
  Box,
  Dialog,
  Button,
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
  keyframes,
  CircularProgress,
  InputAdornment,
} from "@mui/material";
import styled from "@emotion/styled";
import styles from "../../pages/login/components/loginForm.module.css";
import { CustomIconButton } from "../Custom/CustomIconButton";
import { CustomInput } from "../Custom/Input";
import { VisibilityOff } from "@mui/icons-material";
import { Visibility } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { ALERT_DIALOG } from "../../store/constants/auth";

const bounceAnimation = keyframes`
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(1.1);
  }
  50% {
    transform: scale(0.9);
  }
  75% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
`;

const CustomDialogComponent = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    animation: `${bounceAnimation} 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)`,
  },
  "& .MuiDialog-paper": {
    backgroundColor: "black",
    boxShadow: "none",
    borderRadius: "8px",
    border: `1px solid ${theme.palette.secondary.main}`,
  },
}));

const CustomButtonComponent = styled(Button)(({ theme }) => ({
  color: "white",
  backgroundColor: theme.palette.secondary.main,
  borderRadius: "8px",
  border: "none",
  boxShadow:
    " 0px 30px 80px 0px rgba(255, 0, 255, 0.30), 0px 0px 20px 0px rgba(0, 0, 0, 0.60) inset",
  "&:hover": {
    boxShadow:
      " 0px 30px 80px 0px rgba(255, 0, 255, 0.30), 0px 0px 20px 0px rgba(0, 0, 0, 0.60) inset",
  },
}));

const CustomCancelButtonComponent = styled(Button)(() => ({
  color: "white",
  backgroundColor: "black",
  borderRadius: "8px",
  border: "none",
  boxShadow: "  0px 0px 20px 0px gray inset",
  "&:hover": {
    color: "white",
    backgroundColor: "black",
    borderRadius: "8px",
    border: "none",
    boxShadow: "  0px 0px 10px 0px gray inset",
  },
}));

export const CustomDialog = ({
  open,
  title,
  message,
  onClose,
  onOk,
  okLabel = "Ok",
  closeLabel = "Cancel",
  isLoading,
  confirmPassword = false,
  password = "",
  setPassword = () => {},
  autoClose = true,
  showError = false,
  setShowError,
}) => {
  const [passwordModalOpen, setPasswordModalOpen] = React.useState(false);
  const buttonRef = React.useRef(null);

  React.useEffect(()=>{

    if(showError){
      setPasswordModalOpen(true)
    }
  }, [showError])

  return (
    <CustomDialogComponent
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onClose(event, reason);
        }
      }}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        <Typography variant="h4" color="secondary">
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">{message}</Typography>
      </DialogContent>
      <DialogActions>
        <CustomCancelButtonComponent onClick={onClose}>
          {closeLabel}
        </CustomCancelButtonComponent>
        {onOk && okLabel && (
          <CustomButtonComponent
            onClick={() => {
              if (!confirmPassword) {
                onOk();
              } else {
                setPasswordModalOpen(true);
              }
            }}
          >
            {isLoading ? <CircularProgress size={22} /> : okLabel}
          </CustomButtonComponent>
        )}
      </DialogActions>
      <PasswordConfirmModal
        open={passwordModalOpen}
        submitHandler={() => {
          onOk();
          if (!showError) {
            setPasswordModalOpen(false);
          }
          onClose();
        }}
        onClose={() => {
          setPasswordModalOpen(false);
          setShowError(false)
        }}
        password={password}
        setPassword={setPassword}
        showError={showError}
      />
    </CustomDialogComponent>
  );
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  boxShadow: 24,
  p: 4,
  minWidth: "700px",
  borderRadius: "16px",
  padding: "20px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  zIndex: 9,
};

function PasswordConfirmModal({
  open,
  submitHandler,
  onClose,
  password,
  setPassword,
  showError,
}) {
  // const [password, setPassword] = React.useState("");
  const [showPass, setShowPass] = React.useState(false);

  const togglePasswordHide = () => {
    setShowPass(!showPass);
  };

  return (
    <Modal
      className="modelBox"
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box>
          <Typography
            sx={{
              paddingBottom: "40px",
            }}
            variant="h4"
          >
            Please enter the password to confirm
          </Typography>
          <Box>
            {/* <InputLabel className={styles["label"]}>Enter Password</InputLabel> */}
            <CustomInput
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type={showPass ? "text" : "password"}
              fullWidth
              placeholder="Enter your password"
              endAdornment={
                <InputAdornment position="end">
                  <CustomIconButton
                    aril-label="toggle password"
                    onClick={togglePasswordHide}
                  >
                    {showPass ? <VisibilityOff /> : <Visibility />}
                  </CustomIconButton>
                </InputAdornment>
              }
            />
            {showError && (
              <Typography variant="h6" color="error">
                Password is invalid. Please try again.
              </Typography>
            )}
          </Box>
          <Box
            marginTop={3}
            className={styles["btnContainer"]}
            sx={{
              textAlign: "end",
            }}
          >
            <Button
              className={styles["signIn"]}
              onClick={() => submitHandler()}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}


const ContractorApproveModal = ({
  title,
  onOk,
  onClose,
  isLoading,
  onIncorrectInput,
  okLabel,
  closeLabel
}) => {

  // react-redux hooks start...
  const dispatch = useDispatch();
  // react-redux hooks end...

  const confirmApproveText = React.useMemo(() => {
    return "Confirm";
  }, []);

  const [confirmApprove, setConfirmApprove] = React.useState("");

  return (
    <CustomDialogComponent
      open={true}
      // onClose={(event, reason) => {
      //   if (reason !== "backdropClick") {
      //     onClose(event, reason);
      //   }
      // }}
      fullWidth
      maxWidth="sm"
    >
      <Box
        sx={{
          padding: "0.5rem 1rem"
        }}
      >
        <DialogTitle
          sx={{
            padding: "0.5rem 0.5rem 1rem 0.5rem"
          }}
        >
          <Typography variant="h4" color="secondary"
            sx={{
              fontSize: "1.45rem"
            }}
          >
            {title}
          </Typography>
        </DialogTitle>
        <Box>
          {/* <Typography
            sx={{
              paddingBottom: "40px",
            }}
            variant="h4"
          >
            Please enter the password to confirm
          </Typography> */}
          <Box
            sx={{
              padding: "0 0.5rem"
            }}
          >
            {/* <InputLabel className={styles["label"]}>Enter Password</InputLabel> */}
            <CustomInput
              sx={{
                height: "2.75rem !important"
              }}
              name="confirm"
              value={confirmApprove}
              onChange={(e) => setConfirmApprove(e.target.value)}
              type={"text"}
              fullWidth
              placeholder={`${confirmApproveText}`}
            />
            {/* {showError && (
              <Typography variant="h6" color="error">
                Password is invalid. Please try again.
              </Typography>
            )} */}
          </Box>
        </Box>
        <DialogActions
          sx={{
            marginTop: "0.5rem"
          }}
        >
          <CustomCancelButtonComponent onClick={onClose}>
            {closeLabel}
          </CustomCancelButtonComponent>
          {onOk && okLabel && (
            <CustomButtonComponent
              onClick={() => {
                if (confirmApprove === confirmApproveText) {
                  onOk();
                } else {
                  dispatch({
                    type: ALERT_DIALOG,
                    payload: {
                      open: true,
                      title: "Error!",
                      message: `Incorrect. Please type: ${confirmApproveText}`,
                      onOk: () => {
                        setConfirmApprove("")
                      },
                      onClose: () => {
                        setConfirmApprove("")
                      }
                    }
                  })
                }
              }}
            >
              {isLoading ? <CircularProgress size={22} /> : okLabel}
            </CustomButtonComponent>
          )}
        </DialogActions>
      </Box>
    </CustomDialogComponent>
  );
};

const CustomMessageDialogComponent = ({
  OkButton,
  onCloseHandler,
  title,
  message,
  onClose,
  styles
}) => {

  return (
    <CustomDialogComponent
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onClose(event, reason);
        }
      }}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        <Typography
          variant="h4"
          color="secondary"
          sx={{
            textAlign: styles?.message?.textAlign || "left",
          }}
        >
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography
          variant="body1"
          component="div"
          sx={{
            textAlign: styles?.message?.textAlign || "left",
          }}
        >
          <span dangerouslySetInnerHTML={{ __html: message }} />
          {/* {message} */}
        </Typography>
      </DialogContent>
      <DialogActions>
        <CustomCancelButtonComponent onClick={onCloseHandler}>
          Close
        </CustomCancelButtonComponent>
        {OkButton}
      </DialogActions>
    </CustomDialogComponent>
  );
};

const BulkContractorErrorsDialog = ({
  title,
  errors,
  onCloseHandler,
}) => {

  return (
    <CustomDialogComponent
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onClose(event, reason);
        }
      }}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        <Typography
          variant="h4"
          color="secondary"
          sx={{
            textAlign: styles?.message?.textAlign || "left",
          }}
        >
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {errors?.map?.(error => {
          return (
            <Typography
              key={error}
              variant="body1"
              component="div"
              sx={{
                textAlign: styles?.message?.textAlign || "left",
              }}
            >
              <span dangerouslySetInnerHTML={{ __html: error }} />
              {/* {message} */}
            </Typography>
          )
        })} 
      </DialogContent>
      <DialogActions>
        <CustomCancelButtonComponent onClick={onCloseHandler}>
          Close
        </CustomCancelButtonComponent>
      </DialogActions>
    </CustomDialogComponent>
  );
};

export {
  ContractorApproveModal,
  BulkContractorErrorsDialog,
  CustomMessageDialogComponent,
};